import React from "react";
import { Helmet } from "react-helmet";

import bgImage from "../assets/images/bg-3.webp";

const INSCRIPTION_URL = "https://cursos.seguridadallimite.com/#/student/inscription";
const CERTIFICATE_URL = "https://cursos.seguridadallimite.com/#/student/certificate";

const HERO_BADGES = [
  { icon: "mdi-check-circle", label: "Certificación SENA" },
  { icon: "mdi-calendar-check", label: "Res. 4272 de 2021" },
  { icon: "mdi-city", label: "Instalaciones propias" },
];

const Section = () => (
  <>
    <Helmet>
      <title>Centro de Entrenamiento para Trabajo Seguro en Alturas en Armenia, Quindío | Seguridad al Límite</title>
      <meta
        name="description"
        content="Centro autorizado para certificación y entrenamiento en trabajo seguro en alturas en Armenia. Cursos certificados por el SENA, instructores expertos y modernas instalaciones."
      />
      <meta
        name="keywords"
        content="trabajo en alturas armenia, certificación trabajo en alturas quindío, curso trabajo en alturas, entrenamiento alturas, SENA"
      />
      <link rel="canonical" href="https://seguridadallimite.com/" />
      <link rel="preload" as="image" href={bgImage} />
    </Helmet>

    <section className="hero" id="home">
      <div className="hero-layout">
        <div className="hero-copy">
          <p className="hero-kicker">Centro autorizado SENA · Armenia, Quindío</p>

          <h1 className="hero-title">
            Centro de Entrenamiento para Trabajo Seguro en Alturas
          </h1>

          <p className="hero-lead">
            Formación especializada en seguridad y salud en el trabajo, con
            instructores expertos, normativa vigente y certificación SENA.
          </p>

          <div className="hero-actions" id="home-cta">
            <a href={INSCRIPTION_URL} className="btn btn-primary amarillo hero-btn">
              Inscríbete ahora
            </a>
            <a href={CERTIFICATE_URL} className="btn hero-btn hero-btn-outline">
              Verificar certificado
            </a>
          </div>

          <ul className="hero-badges">
            {HERO_BADGES.map((badge) => (
              <li key={badge.label} className="hero-badge">
                <i className={`mdi ${badge.icon}`} aria-hidden="true"></i>
                <span>{badge.label}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="hero-media">
          <img
            src={bgImage}
            alt="Técnico asegurado con arnés en estructura de entrenamiento en alturas"
            width="960"
            height="1080"
            loading="eager"
            fetchPriority="high"
          />
        </div>
      </div>

      <p className="hero-footnote">Seguridad al Límite SAS · Armenia, Quindío</p>
    </section>
  </>
);

export default Section;
